<div *ngIf="dataImport as di">
    <div class="detail-header">
        <div class="title-row">
            <h2>{{ di.dryRun ? 'Prueba de importación' : 'Importación' }} {{ typeLabels[di.importType] }}</h2>
            <p-tag *ngIf="di.dryRun" value="Prueba" severity="info"></p-tag>
            <p-tag [value]="statusLabels[di.status]" [severity]="statusSeverities[di.status]"></p-tag>
            <button *ngIf="canPromote" pButton type="button" label="Importar de verdad" icon="pi pi-upload"
                class="p-button-sm ml-auto" (click)="promote()"></button>
            <button *ngIf="promotedImportId" pButton type="button" label="Ver la importación" icon="pi pi-arrow-right"
                class="p-button-outlined p-button-sm ml-auto" (click)="openPromoted()"></button>
            <button pButton type="button" label="Exportar PDF" icon="pi pi-file-pdf"
                class="p-button-outlined p-button-sm" [class.ml-auto]="!canPromote && !promotedImportId"
                (click)="pdfMenu.toggle($event)"></button>
            <p-menu #pdfMenu [model]="pdfOptions" [popup]="true" appendTo="body"></p-menu>
            <button pButton type="button" label="Editar y relanzar" icon="pi pi-replay"
                class="p-button-outlined p-button-sm" [disabled]="!canRerun" (click)="openRerun()"></button>
            <button pButton type="button" label="Refrescar" icon="pi pi-refresh"
                class="p-button-outlined p-button-sm" (click)="refresh()"></button>
            <span *ngIf="isRunning" class="auto-refresh">
                <i class="pi pi-sync"></i> Se actualiza sola cada 30 s
            </span>
        </div>
        <div class="meta-row">
            <span><i class="pi pi-cog"></i> Modo: {{ modeLabels[di.mode] }}</span>
            <span *ngIf="di.startedAt"><i class="pi pi-play"></i> Inicio: {{ di.startedAt | date:'dd/MM/yyyy HH:mm' }}</span>
            <span *ngIf="di.finishedAt"><i class="pi pi-flag-fill"></i> Fin: {{ di.finishedAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
    </div>

    <!-- Progress -->
    <div class="progress-card">
        <div class="progress-head">
            <span class="progress-label">Progreso de procesado</span>
            <span class="progress-value">{{ progress }}%</span>
        </div>
        <p-progressBar [value]="progress" [showValue]="false"
            [styleClass]="di.status === 'Error' ? 'pb-danger' : (di.status === 'Completada' ? 'pb-success' : '')">
        </p-progressBar>
        <div class="progress-sub">
            {{ di.processedRows }} de {{ di.totalRows }} filas procesadas<span
                *ngIf="speedLabel"> · {{ speedLabel }}</span><span
                *ngIf="remainingLabel"> · {{ remainingLabel }}</span>
        </div>
    </div>

    <!-- Stat widgets -->
    <div class="stats-grid">
        <div class="stat-card total">
            <div class="stat-icon"><i class="pi pi-list"></i></div>
            <div class="stat-body">
                <span class="stat-value">{{ di.totalRows }}</span>
                <span class="stat-label">Total filas</span>
            </div>
        </div>
        <div class="stat-card processed">
            <div class="stat-icon"><i class="pi pi-sync"></i></div>
            <div class="stat-body">
                <span class="stat-value">{{ di.processedRows }}</span>
                <span class="stat-label">Procesadas</span>
            </div>
        </div>
        <div class="stat-card imported">
            <div class="stat-icon"><i class="pi pi-check-circle"></i></div>
            <div class="stat-body">
                <span class="stat-value">{{ di.importedRows }}</span>
                <span class="stat-label">{{ di.dryRun ? 'Validadas' : 'Importadas' }}</span>
            </div>
        </div>
        <div class="stat-card errors">
            <div class="stat-icon"><i class="pi pi-times-circle"></i></div>
            <div class="stat-body">
                <span class="stat-value">{{ di.errorRows }}</span>
                <span class="stat-label">Errores</span>
            </div>
        </div>
        <div class="stat-card rate">
            <div class="stat-icon"><i class="pi pi-percentage"></i></div>
            <div class="stat-body">
                <span class="stat-value">{{ successRate }}%</span>
                <span class="stat-label">Tasa de éxito</span>
            </div>
        </div>
    </div>

    <div *ngIf="di.errorMessage" class="error-banner">
        <i class="pi pi-exclamation-triangle"></i>
        <span><strong>Mensaje:</strong> {{ di.errorMessage }}</span>
    </div>

    <p-tabView>
        <p-tabPanel header="Detalle">
            <div class="flex align-items-center gap-2 mb-2">
                <p-inputSwitch [ngModel]="onlyErrors" (onChange)="toggleErrors()"></p-inputSwitch>
                <span>Sólo errores</span>
            </div>

            <p-table #rowsGrid [value]="rows" [lazy]="true" (onLazyLoad)="loadRows($event)" [loading]="loadingRows"
                [paginator]="true" [rows]="50" [totalRecords]="rowsTotal" [rowsPerPageOptions]="[50,100,500]"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} filas"
                responsiveLayout="scroll" paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header">
                    <tr><th>Fila</th><th>Estado</th><th>Mensaje</th><th>Entidad</th></tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td>{{ row.rowNumber }}</td>
                        <td><p-tag [value]="rowStatusLabels[row.status]" [severity]="rowStatusSeverities[row.status]"></p-tag></td>
                        <td class="msg-col">{{ row.errorMessage || '-' }}</td>
                        <td>{{ row.entityId || '-' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="4" class="text-center p-4">Sin filas para mostrar.</td></tr>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <p-tabPanel header="Resumen">
            <div *ngIf="summary as sum; else summaryLoading">
                <div *ngIf="sum.errorTypes.length" class="summary-block">
                    <h3>Errores por tipo <span class="summary-rows">{{ sum.errorRows }} fila(s)</span></h3>
                    <p-table [value]="sum.errorTypes" responsiveLayout="scroll"
                        sortField="count" [sortOrder]="-1">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="message">Tipo de error <p-sortIcon field="message"></p-sortIcon></th>
                                <th pSortableColumn="count" class="count-col">Veces <p-sortIcon field="count"></p-sortIcon></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-cause>
                            <tr>
                                <td>{{ cause.message }}</td>
                                <td class="count-col">{{ cause.count }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <div *ngIf="sum.errors.length" class="summary-block">
                    <h3>Errores por mensaje <span class="summary-rows">con el dato que falló</span></h3>
                    <p-table [value]="sum.errors" responsiveLayout="scroll"
                        sortField="count" [sortOrder]="-1">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="message">Mensaje <p-sortIcon field="message"></p-sortIcon></th>
                                <th pSortableColumn="count" class="count-col">Veces <p-sortIcon field="count"></p-sortIcon></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-cause>
                            <tr>
                                <td>{{ cause.message }}</td>
                                <td class="count-col">{{ cause.count }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <div *ngIf="sum.skippedTypes.length" class="summary-block">
                    <h3>Omitidas por tipo <span class="summary-rows">{{ sum.skippedRows }} fila(s)</span></h3>
                    <p-table [value]="sum.skippedTypes" responsiveLayout="scroll"
                        sortField="count" [sortOrder]="-1">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="message">Tipo de motivo <p-sortIcon field="message"></p-sortIcon></th>
                                <th pSortableColumn="count" class="count-col">Veces <p-sortIcon field="count"></p-sortIcon></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-cause>
                            <tr>
                                <td>{{ cause.message }}</td>
                                <td class="count-col">{{ cause.count }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <div *ngIf="sum.skipped.length" class="summary-block">
                    <h3>Omitidas por motivo <span class="summary-rows">con el dato concreto</span></h3>
                    <p-table [value]="sum.skipped" responsiveLayout="scroll"
                        sortField="count" [sortOrder]="-1">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="message">Motivo <p-sortIcon field="message"></p-sortIcon></th>
                                <th pSortableColumn="count" class="count-col">Veces <p-sortIcon field="count"></p-sortIcon></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-cause>
                            <tr>
                                <td>{{ cause.message }}</td>
                                <td class="count-col">{{ cause.count }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <p *ngIf="sum.errors.length || sum.skipped.length" class="summary-note">
                    Una fila puede acumular varias causas, así que la suma de la columna
                    puede superar al número de filas.
                </p>

                <p *ngIf="!sum.errors.length && !sum.skipped.length" class="text-center p-4">
                    Ninguna fila con error ni omitida.
                </p>
            </div>
            <ng-template #summaryLoading>
                <p class="text-center p-4">{{ loadingSummary ? 'Calculando resumen…' : 'No se pudo cargar el resumen.' }}</p>
            </ng-template>
        </p-tabPanel>
    </p-tabView>

    <p-dialog header="Editar y relanzar" [(visible)]="showRerun" [modal]="true" [style]="{width: '32rem'}">
        <div class="flex flex-column gap-3">
            <div>
                <label class="block mb-1">Modo</label>
                <p-dropdown [options]="modes" [(ngModel)]="rerunOptions.mode" appendTo="body" styleClass="w-full"></p-dropdown>
            </div>

            <div class="flex align-items-center gap-2">
                <p-inputSwitch [(ngModel)]="rerunOptions.dryRun"></p-inputSwitch>
                <span>Modo prueba (no guarda datos)</span>
            </div>

            <div class="flex align-items-center gap-2">
                <p-inputSwitch [(ngModel)]="rerunOptions.stopOnFirstError" [disabled]="rerunOptions.dryRun"></p-inputSwitch>
                <span [class.text-400]="rerunOptions.dryRun">Parar en el primer error</span>
            </div>

            <div class="flex align-items-center gap-2">
                <p-inputSwitch [(ngModel)]="rerunOptions.allowDuplicates"></p-inputSwitch>
                <span>Permitir duplicados</span>
            </div>

            <div class="flex align-items-center gap-2">
                <p-inputSwitch [(ngModel)]="rerunOptions.truncateValues"></p-inputSwitch>
                <span>Truncar automáticamente los valores demasiado largos</span>
            </div>

            <p class="rerun-note">
                Se procesa el mismo fichero entero otra vez y se descartan las filas de la ejecución
                anterior. Lo que ya se importó no se borra: para no duplicarlo, deja los duplicados
                comprobados y usa «Crear y actualizar».
            </p>
        </div>

        <ng-template pTemplate="footer">
            <button pButton label="Cancelar" class="p-button-text" (click)="showRerun = false"></button>
            <button pButton label="Relanzar" icon="pi pi-replay" [loading]="rerunning" (click)="rerun()"></button>
        </ng-template>
    </p-dialog>

    <p-confirmDialog></p-confirmDialog>
</div>
